module.exports = {"530103001":"拓东街道","530103002":"鼓楼街道","530103003":"东华街道","530103004":"联盟街道","530103005":"金辰街道","530103006":"青云街道","530103007":"龙泉街道","530103008":"茨坝街道","530103009":"双龙街道","530103010":"松华街道","530103011":"滇源街道","530103012":"阿子营街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530103.json
// module id = 2673
// module chunks = 0